import React from 'react';
import { defaultListProps } from '~constants/config';
import { List, TextField, EditButton, DeleteWithConfirmButton } from 'react-admin';
import CustomDatagrid from '~components/CustomDatagrid';

function FinanciadorEstudiosList({ ...props }) {
  return (
    <List {...defaultListProps} {...props}>
      <CustomDatagrid rowClick="edit">
        <TextField source="id" />
        <TextField source="nameEs" />
        <TextField source="nameEn" />
        <TextField source="namePt" />
        <DeleteWithConfirmButton label="" />
        <EditButton label="" />
      </CustomDatagrid>
    </List>
  );
}

export default FinanciadorEstudiosList;
